import type { BrandConfig } from '../types';

/** RoyalX / HeroGames — dark + orange theme. */
export const royalx: BrandConfig = {
  id: 'royalx',
  name: 'HeroGames',
  displayName: 'RoyalX Club',
  title: 'HeroGames',
  colors: {
    // #FF6B00  ->  hsl(25 100% 50%)
    primaryHsl: '25 100% 50%',
    primary: '#FF6B00',
    headerGradient: ['#1A1108', '#0F0F0F'],
    buttonGradient: ['#1a1a1a', '#FF6B00'],
  },
  features: {
    // RoyalX ne abhi ye features enable nahi kiye — flag se off.
    fantasy: false,
    aggregator: false,
    liveCasino: false,
    slots: false,
    downloadApk: false,
  },
  urls: {
    app: import.meta.env.VITE_APP_URL ?? 'https://herogams.fun',
  },
  supportEmail: 'info@herogams.fun',
  assets: {
    logo: '/brands/royalx/logo.png',
    favicon: '/brands/royalx/favicon.ico',
    appleTouchIcon: '/brands/royalx/apple-touch-icon.png',
  },
};
